import { categories } from 'global/data';

export default function getCategoryId(slug) {
  const category = categories.find(category => category.url_key === slug);

  const id = category?.id.toString();
  
  return id;
}
